import {
  ControlWithDescription,
  InlineWithDescription,
} from 'components/form-layouts';

import { RffChipInput } from '@cast/shared-rff-ui';

export const NebiusReservationIdsSection = () => (
  <InlineWithDescription
    description={
      <ControlWithDescription label="Capacity reservations">
        Provide Nebius capacity block reservation IDs to allocate edge nodes
        from pre-reserved GPU capacity.
      </ControlWithDescription>
    }
    controls={
      <RffChipInput
        name="reservationIds"
        label="Reservation IDs"
        placeholder="Enter reservation IDs"
        testId="reservation-ids-chip-input"
        separators={['Enter', ',', ' ']}
        hint="Enter comma-separated values"
        onKeyDown={(e) => {
          // since "Enter" key is used to add a chip, we need to prevent the default behavior
          // to prevent the form from submitting
          if (e.key === 'Enter') {
            e.preventDefault();
          }
        }}
      />
    }
  />
);
